import script from "./VehicleDashboardSelectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleDashboardSelectModal.vue?vue&type=script&setup=true&lang=js"

import "./VehicleDashboardSelectModal.vue?vue&type=style&index=0&id=d8cb974c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8cb974c"]])

export default __exports__